{
  "common": {
    "appName": "TrasaFlow",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "close": "Schließen",
    "retry": "Erneut versuchen",
    "loading": "Wird geladen …",
    "back": "Zurück",
    "yes": "Ja",
    "no": "Nein",
    "all": "Alle",
    "reset": "Zurücksetzen",
    "notAvailableYet": "Noch nicht verfügbar",
    "required": "Pflichtfeld",
    "none": "–"
  },
  "a11y": {
    "skipToContent": "Zum Inhalt springen",
    "mainNav": "Hauptnavigation",
    "openMenu": "Menü öffnen",
    "menuTitle": "Navigation"
  },
  "header": {
    "organization": "Organisation",
    "user": "Angemeldeter Nutzer",
    "language": "Sprache",
    "logout": "Abmelden",
    "passkey": "Passkey einrichten",
    "userMenu": "Nutzermenü"
  },
  "language": {
    "hr": "Hrvatski",
    "de": "Deutsch",
    "en": "English"
  },
  "orgKind": {
    "GC": "Generalunternehmer",
    "CLIENT": "Auftraggeber",
    "SUB": "Nachunternehmer"
  },
  "nav": {
    "tasks": "Meine Aufgaben",
    "inbox": "Posteingang",
    "orders": "Aufträge",
    "map": "Karte",
    "calendar": "Kalender",
    "review": "Prüfung",
    "pits": "Gruben",
    "deadlines": "Fristen",
    "crews": "Kolonnen",
    "users": "Nutzer",
    "dashboard": "Dashboard",
    "formsPreview": "Formular-Vorschau",
    "imports": "OTW-Import",
    "forms": "Formulare",
    "areas": "Gebiete",
    "dispatch": "Wochenplan",
    "permits": "Genehmigungen"
  },
  "pages": {
    "tasks": {
      "title": "Meine Aufgaben",
      "description": "Alles, was heute von Ihnen eine Entscheidung oder Aktion braucht.",
      "emptyTitle": "Keine offenen Aufgaben",
      "emptyBody": "Sobald Aufträge zugewiesen, Prüfungen fällig oder Fristen kritisch werden, erscheinen sie hier."
    },
    "map": {
      "title": "Karte",
      "description": "Aufträge, Baugruben und Kolonnen auf der Karte.",
      "emptyTitle": "Die Karte wird vorbereitet",
      "emptyBody": "Hier erscheinen die Standorte der Aufträge und Gruben, sobald die Kartenansicht angebunden ist."
    },
    "calendar": {
      "title": "Kalender",
      "description": "Disposition der Kolonnen und Termine.",
      "emptyTitle": "Keine Termine",
      "emptyBody": "Terminierte Aufträge und Kolonneneinsätze erscheinen hier. Sperren wie offene Gruben oder fehlende Genehmigungen werden direkt markiert."
    },
    "review": {
      "title": "Prüfung",
      "description": "Fotos, Stunden und Meldungen „abseits“ zur Freigabe.",
      "emptyTitle": "Nichts zu prüfen",
      "emptyBody": "Fertiggemeldete Arbeitsschritte und auffällige Nachweise landen hier in der Prüfwarteschlange."
    },
    "pits": {
      "title": "Gruben",
      "description": "Offene, provisorisch und fertig verschlossene Baugruben.",
      "emptyTitle": "Keine Gruben erfasst",
      "emptyBody": "Gruben aus den Tiefbau-Formularen erscheinen hier mit Zustand, Karte und Filter."
    },
    "deadlines": {
      "title": "Fristen",
      "description": "Anstehende und abgelaufene Fristen mit Warnstufen.",
      "emptyTitle": "Keine Fristen",
      "emptyBody": "Fristen zu Aufträgen und Genehmigungen werden hier mit Verantwortlichem und Quittungsstand angezeigt."
    },
    "crews": {
      "title": "Kolonnen",
      "description": "Kolonnen Ihres Unternehmens verwalten.",
      "emptyTitle": "Noch keine Kolonnen",
      "emptyBody": "Legen Sie Kolonnen an, damit Aufträge und Arbeitsschritte zugewiesen werden können."
    },
    "users": {
      "title": "Nutzer",
      "description": "Nutzer und Rollen Ihrer Organisation.",
      "emptyTitle": "Keine weiteren Nutzer",
      "emptyBody": "Eingeladene Nutzer und ihre Rollen erscheinen hier."
    },
    "dashboard": {
      "title": "Dashboard",
      "description": "Überblick über Aufträge, Fristen und Fortschritt (Lesezugang).",
      "emptyTitle": "Noch keine Kennzahlen",
      "emptyBody": "Sobald Aufträge vorliegen, sehen Sie hier Stand, Fristen und Fertigstellung auf einen Blick."
    },
    "permits": {
      "title": "Genehmigungen",
      "description": "Antragspostfach: Eingänge der Behörden, die keinem Antrag zugeordnet sind. Anträge selbst bearbeiten Sie am Auftrag."
    }
  },
  "login": {
    "title": "Bei TrasaFlow anmelden",
    "intro": "Die Anmeldung läuft über den zentralen Anmeldedienst Ihrer Organisation.",
    "button": "Anmelden",
    "loggedOut": "Sie wurden abgemeldet.",
    "expired": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    "error": "Die Anmeldung ist fehlgeschlagen."
  },
  "authCallback": {
    "working": "Anmeldung wird abgeschlossen …",
    "errorTitle": "Anmeldung fehlgeschlagen",
    "errorBody": "Der Anmeldedienst hat die Anmeldung nicht bestätigt. Bitte versuchen Sie es erneut."
  },
  "meError": {
    "title": "Ihr Konto konnte nicht geladen werden",
    "body": "Die Nutzerdaten sind gerade nicht erreichbar. Versuchen Sie es erneut oder melden Sie sich ab.",
    "forbidden": "Für Ihr Konto ist in TrasaFlow kein Zugang eingerichtet. Bitte wenden Sie sich an Ihre Administration."
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "body": "Diese Adresse gibt es nicht.",
    "home": "Zur Startseite"
  },
  "forbidden": {
    "title": "Kein Zugriff",
    "body": "Für diese Seite fehlt Ihnen das nötige Recht."
  },
  "errors": {
    "generic": "Etwas ist schiefgelaufen.",
    "http": "Der Server meldet einen Fehler ({{status}}).",
    "network": "Keine Verbindung zum Server.",
    "notConnectedTitle": "Noch nicht angebunden",
    "notConnectedBody": "Das Backend stellt diese Daten noch nicht bereit. Sie erscheinen hier, sobald der Endpunkt verfügbar ist."
  },
  "filters": {
    "title": "Filter",
    "max": "Höchstens {{count}} Filter je Liste"
  },
  "orders": {
    "title": "Aufträge",
    "description": "Aufträge Ihrer Organisation.",
    "filterStatus": "Status",
    "filterSearch": "Suche",
    "searchPlaceholder": "Nummer, Adresse oder Referenz",
    "colNumber": "Auftrag",
    "colStatus": "Status",
    "colAddress": "Adresse",
    "colDeadline": "Nächste Frist",
    "emptyTitle": "Keine Aufträge",
    "emptyBody": "Zu diesen Filtern gibt es keine Aufträge.",
    "unavailableTitle": "Auftragsliste noch nicht angebunden",
    "unavailableBody": "Der Server stellt die Auftragsliste noch nicht bereit. Sobald sie verfügbar ist, erscheint sie hier.",
    "listLabel": "Auftragsliste",
    "filterOrderType": "Auftragsart",
    "filterArea": "Gebiet",
    "filterSub": "Nachunternehmer",
    "filterAmpel": "Frist-Ampel",
    "groupBy": "Gebiete gruppieren nach",
    "areasTitle": "Gebiete",
    "areaName": "Gebiet",
    "areaOpen": "Offen",
    "areaTotal": "Gesamt",
    "areaNext": "Nächste Frist",
    "areaPits": "Offene Gruben",
    "areaFilter": "Aufträge anzeigen",
    "areaNone": "(ohne Gebiet)",
    "colType": "Art",
    "colArea": "Gebiet",
    "colAssigned": "Sub",
    "selectAll": "Alle geladenen Aufträge auswählen",
    "selectRow": "Auftrag {{number}} auswählen",
    "selectedCount": "{{count}} ausgewählt",
    "loadMore": "Mehr laden",
    "loadedCount": "{{count}} Aufträge geladen",
    "allLoaded": "Alle Aufträge geladen",
    "subShort": "Sub {{id}}",
    "noSub": "ohne Sub",
    "groupByValue": {
      "rajon": "Rajon",
      "municipality": "Gemeinde",
      "postal_code": "Postleitzahl",
      "mdf": "MDF"
    }
  },
  "order": {
    "back": "Zur Auftragsliste",
    "unavailableTitle": "Auftrag nicht verfügbar",
    "unavailableBody": "Dieser Auftrag existiert nicht, ist für Sie nicht sichtbar oder die Detailansicht ist noch nicht angebunden.",
    "number": "Auftragsnummer",
    "externalRef": "Referenz Auftraggeber",
    "status": "Status",
    "clientStatus": "Status beim Auftraggeber",
    "address": "Adresse",
    "region": "Region",
    "nextDeadline": "Nächste Frist",
    "version": "Version",
    "actions": "Aktionen zum Auftrag",
    "noActions": "Für Sie sind in diesem Zustand keine Aktionen möglich.",
    "blockers": "Das verhindert die Aktion",
    "done": "Aktion „{{action}}“ ausgeführt.",
    "type": "Auftragsart",
    "area": "Gebiet",
    "nearbyTitle": "In der Nähe",
    "nearbyRadius": "Umkreis",
    "nearbyEmpty": "Keine offenen Aufträge im Umkreis.",
    "nearbyError": "Aufträge in der Nähe konnten nicht geladen werden.",
    "distance": "{{m}} m",
    "stepsTitle": "Arbeitsschritte",
    "stepsEmpty": "Noch keine Arbeitsschritte.",
    "deadlinesTitle": "Fristen",
    "deadlinesEmpty": "Keine Fristen.",
    "crewTitle": "Kolonne",
    "actionDue": "Handlungsfrist",
    "notFoundTitle": "Auftrag nicht gefunden",
    "notFoundBody": "Dieser Auftrag existiert nicht oder ist für Sie nicht sichtbar.",
    "stepStatus": {
      "OPEN": "Offen",
      "IN_PROGRESS": "In Arbeit",
      "DONE": "Erledigt",
      "NEEDS_FOLLOWUP": "Folgearbeit nötig",
      "BLOCKED": "Blockiert",
      "NOT_APPLICABLE": "Entfällt"
    },
    "deadlineState": {
      "OPEN": "Offen",
      "EXTENDED": "Verlängert",
      "OVERDUE": "Handlungsfrist überschritten",
      "EXPIRED": "Abgelaufen",
      "DONE": "Erledigt",
      "CANCELLED": "Abgebrochen"
    },
    "reschedule": "Umplanen",
    "subCrew": "Kolonne des Nachunternehmers (optional)",
    "assignSub": "Nachunternehmer",
    "tabs": "Ansichten des Auftrags",
    "tab": {
      "details": "Details",
      "history": "Verlauf"
    }
  },
  "orderStatus": {
    "NEW": "Neu",
    "CLASSIFIED": "Klassifiziert",
    "ASSIGNED": "Vergeben",
    "ACCEPTED": "Angenommen",
    "SCHEDULED": "Terminiert",
    "IN_PROGRESS": "In Ausführung",
    "BLOCKED": "Blockiert",
    "COMPLETION_REPORTED": "Fertig gemeldet",
    "GC_APPROVED": "GU geprüft",
    "REPORTED_TO_CLIENT": "An Auftraggeber gemeldet",
    "CLIENT_ACCEPTED": "Abgenommen",
    "BILLED": "Abgerechnet",
    "CANCELLED": "Storniert"
  },
  "orderAction": {
    "CLASSIFY": "Klassifizieren",
    "ASSIGN": "Vergeben",
    "HAND_OVER": "Übergeben",
    "ACCEPT": "Annehmen",
    "REJECT": "Ablehnen",
    "SCHEDULE": "Terminieren",
    "START": "Starten",
    "BLOCK": "Blockieren",
    "UNBLOCK": "Blockade aufheben",
    "REPORT_COMPLETION": "Fertig melden",
    "APPROVE": "Freigeben",
    "RETURN_FOR_REWORK": "Zur Nacharbeit zurückgeben",
    "REPORT_TO_CLIENT": "An Auftraggeber melden",
    "RECORD_CLIENT_ACCEPTANCE": "Abnahme erfassen",
    "MARK_BILLED": "Als abgerechnet markieren",
    "CANCEL": "Stornieren"
  },
  "confirm": {
    "title": "„{{action}}“ bestätigen?",
    "description": "Die Aktion wird sofort ausgeführt.",
    "irreversibleTitle": "„{{action}}“ ist nicht umkehrbar",
    "irreversibleDescription": "Diese Aktion lässt sich nicht rückgängig machen. Bitte begründen Sie sie; die Begründung wird protokolliert.",
    "reasonLabel": "Begründung",
    "reasonHint": "Mindestens {{count}} Zeichen",
    "reasonTooShort": "Die Begründung ist zu kurz.",
    "pending": "Wird ausgeführt …",
    "failed": "Die Aktion wurde nicht ausgeführt."
  },
  "inbox": {
    "title": "Posteingang",
    "description": "Fristwarnungen, Eskalationen, Zuweisungen und Sync-Konflikte.",
    "emptyTitle": "Alles erledigt",
    "emptyBody": "Es liegen keine Meldungen für Sie vor.",
    "unavailableTitle": "Posteingang noch nicht angebunden",
    "unavailableBody": "Der Server liefert den Posteingang noch nicht. Pflichtmeldungen erscheinen später hier und oben auf jeder Seite.",
    "stateLabel": "Anzeige",
    "state": {
      "open": "Offen",
      "acknowledged": "Quittiert",
      "all": "Alle"
    },
    "kind": {
      "DEADLINE_WARNING": "Fristwarnung",
      "DEADLINE_EXPIRED": "Frist abgelaufen",
      "ESCALATION": "Eskalation",
      "SYNC_CONFLICT": "Sync-Konflikt",
      "ASSIGNMENT": "Zuweisung",
      "PERMIT": "Genehmigung",
      "SYSTEM": "System"
    },
    "severity": {
      "INFO": "Information",
      "WARNING": "Warnung",
      "CRITICAL": "Kritisch"
    },
    "acknowledge": "Quittieren",
    "acknowledging": "Wird quittiert …",
    "ackFailed": "Die Quittung ist fehlgeschlagen. Bitte erneut versuchen.",
    "goToAction": "Zur Aktion",
    "mandatoryTitle": "Pflichtmeldung: Quittierung erforderlich",
    "mandatoryRegion": "Pflichtmeldungen",
    "ackDue": "Quittieren bis {{date}}",
    "acknowledgedAt": "Quittiert am {{date}}",
    "listLabel": "Meldungen",
    "mandatoryCount": "{{count}} Pflichtmeldung(en) warten auf Quittierung"
  },
  "forms": {
    "previewTitle": "Formular-Vorschau",
    "previewDescription": "Zeigt Formulardefinitionen so, wie die Feld-App sie auswertet. Es wird nichts gespeichert.",
    "selectForm": "Formular",
    "version": "Version {{version}}",
    "formArea": "Formular",
    "resultArea": "Auswertung",
    "outcome": "Ergebnis",
    "noOutcome": "Noch kein Ergebnis (Pflichtfelder fehlen oder Werte ungültig)",
    "stepStatus": "Schrittstatus",
    "pitState": "Grubenzustand",
    "pitDetails": "Fehlender Belag",
    "followUps": "Folgeschritte",
    "missingFields": "Fehlende Pflichtfelder",
    "invalidFields": "Ungültige Werte",
    "visibleCount": "Sichtbare Felder: {{count}}",
    "none": "keine",
    "clearAnswers": "Antworten leeren",
    "validate": "Eingaben prüfen",
    "choose": "Bitte wählen",
    "errorMissing": "Pflichtfeld",
    "errorInvalid": "Ungültiger Wert",
    "photoAdd": "Dateien wählen",
    "photoNote": "Vorschau: Fotos werden hier nicht hochgeladen, nur gezählt. Mindestens {{min}}.",
    "photoNoteMax": "Mindestens {{min}}, höchstens {{max}}.",
    "photoCount": "{{count}} Datei(en) gewählt",
    "photoRemove": "Entfernen",
    "signerName": "Name der unterschreibenden Person",
    "signatureToggle": "Unterschrift als vorhanden markieren",
    "pitLabel": "Muffenbezeichnung oder Grubenname",
    "unsupported": "Dieser Feldtyp wird in der Web-Vorschau nicht dargestellt.",
    "geometryNote": "Geometrie wird in der Feld-App erfasst.",
    "noPermission": "Für die Formular-Vorschau fehlt das Recht.",
    "stepStatusValue": {
      "DONE": "Erledigt",
      "NEEDS_FOLLOWUP": "Folgearbeit nötig",
      "IN_PROGRESS": "In Arbeit",
      "BLOCKED": "Blockiert"
    },
    "pitStateValue": {
      "offen": "Offen",
      "provisorisch": "Provisorisch verschlossen",
      "fertig": "Fertig"
    },
    "pitDetailValue": {
      "asphalt_fehlt": "Asphalt fehlt",
      "pflaster_fehlt": "Pflaster fehlt"
    }
  },
  "bundle": {
    "action": "Als Tagesbündel zuweisen",
    "title": "Tagesbündel zuweisen",
    "description": "{{count}} Aufträge werden vergeben und für den gewählten Tag gebündelt. Ist ein Auftrag nicht bündelbar, ändert sich nichts.",
    "day": "Tag",
    "done": "Tagesbündel für {{day}} mit {{count}} Aufträgen angelegt.",
    "target": "Kolonne oder Nachunternehmer",
    "ASSIGNEE_WITHOUT_PRICE_LIST": "keine Preisliste",
    "crewOption": "Eigene Kolonne",
    "subOption": "Nachunternehmer",
    "targetsUnavailable": "Die Liste der Kolonnen und Nachunternehmer ist nicht verfügbar. Bitte später erneut versuchen."
  },
  "ampel": {
    "red": "Überfällig",
    "amber": "Fällig in 3 Tagen",
    "green": "Im Plan",
    "none": "Ohne Frist",
    "done": "Erledigt"
  },
  "map": {
    "listTitle": "Aufträge auf der Karte ({{count}})",
    "truncated": "Es werden nur die ersten {{count}} Aufträge angezeigt. Bitte Filter eingrenzen.",
    "canvasLabel": "Karte der Aufträge. Dieselben Aufträge stehen darunter als Liste.",
    "legend": "Frist-Ampel",
    "noLocation": "{{count}} Aufträge ohne Standort sind nicht auf der Karte, aber in der Liste.",
    "error": "Die Karte konnte nicht geladen werden.",
    "loadError": "Aufträge konnten nicht geladen werden.",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "resetNorth": "Norden ausrichten"
  },
  "imports": {
    "title": "OTW-Import",
    "description": "OTW-Liste hochladen oder einfügen, die Vorschau prüfen und mit einem Klick übernehmen.",
    "clientId": "Auftraggeber",
    "clientIdHint": "Der Auftraggeber, dessen OTW-Liste importiert wird.",
    "file": "Datei (XLSX, CSV oder TSV)",
    "paste": "Oder TSV einfügen",
    "pasteHint": "Kopfzeile und Zeilen aus OTW, durch Tabulatoren getrennt.",
    "preview": "Vorschau erstellen",
    "previewing": "Vorschau wird erstellt …",
    "noInput": "Datei wählen oder TSV einfügen.",
    "summaryTitle": "Ergebnis der Vorschau",
    "source": "Quelle",
    "rowsTitle": "Zeilen",
    "outcomeFilter": "Ergebnis anzeigen",
    "colRow": "Zeile",
    "colRef": "Referenz",
    "colOutcome": "Ergebnis",
    "colChanges": "Änderungen",
    "emptyRows": "Keine Zeilen für diesen Filter.",
    "outcome": {
      "NEW": "Neu",
      "CHANGED": "Geändert",
      "UNCHANGED": "Unverändert",
      "INVALID": "Ungültig",
      "MISSING": "Fehlt in der Liste"
    },
    "diff": "{{field}}: {{from}} → {{to}}",
    "commit": "Übernehmen",
    "commitDescription": "{{new}} neue und {{changed}} geänderte Aufträge werden übernommen. {{missing}} Aufträge fehlen in der Liste und sind Storno-Kandidaten.",
    "committed": "Import übernommen: {{new}} neu, {{changed}} geändert.",
    "viewOrders": "Zu den Aufträgen",
    "statusCommitted": "Übernommen",
    "statusPreviewed": "Vorschau"
  },
  "deadlines": {
    "filterType": "Typ",
    "filterResponsible": "Verantwortlich",
    "filterArea": "Gebiet",
    "filterAmpel": "Ampel",
    "filterState": "Zustand",
    "colAmpel": "Ampel",
    "colType": "Typ",
    "colOrder": "Auftrag",
    "colArea": "Gebiet",
    "colActionDue": "Handlungsfrist",
    "colDue": "Ablauf",
    "colResponsible": "Verantwortlich",
    "colState": "Zustand",
    "colAck": "Quittierung",
    "colEscalation": "Eskalation",
    "listLabel": "Fristenliste",
    "emptyTitle": "Keine Fristen",
    "emptyBody": "Zu diesen Filtern gibt es keine Fristen.",
    "me": "Ich",
    "userShort": "Nutzer {{id}}",
    "ackNone": "Keine Meldung",
    "ackOpen": "Offen, bis {{date}}",
    "ackDone": "Quittiert am {{date}}",
    "escalationNone": "keine",
    "escalationLevel": "Stufe {{count}}",
    "loadError": "Fristen konnten nicht geladen werden.",
    "kind": {
      "ACCEPTANCE": "Annahme",
      "ORDER_ACCEPTANCE": "Annahme",
      "VAO": "VAO",
      "PERMIT_VALIDITY": "Genehmigung gültig bis",
      "CLIENT_SLA": "Auftraggeber-Frist",
      "CLIENT_DEADLINE": "Auftraggeber-Frist",
      "CLIENT_SERVICE_TIME": "Servicezeit Auftraggeber"
    }
  },
  "calendar": {
    "viewDay": "Tag",
    "viewWeek": "Woche",
    "viewMonth": "Monat",
    "viewList": "Liste",
    "today": "Heute",
    "calendarLabel": "Fristenkalender",
    "actionDue": "Handlungsfrist",
    "due": "Ablauf",
    "permitExpiry": "Genehmigung läuft ab",
    "icalTitle": "Kalender-Abo (iCal)",
    "icalNote": "Der Abo-Link erscheint hier, sobald das Backend ihn bereitstellt.",
    "legend": "Legende",
    "loadError": "Der Kalender konnte nicht geladen werden.",
    "prev": "Zurück",
    "next": "Weiter",
    "appointment": "Termin",
    "icalCreate": "Abo-Link erzeugen",
    "icalRotate": "Neuen Link erzeugen",
    "icalExists": "Ein Abo-Link ist angelegt. Aus Sicherheitsgründen wird er nur beim Erzeugen angezeigt. Ein neuer Link macht den alten ungültig.",
    "icalLink": "Abo-Link (nur einmal sichtbar, in den Kalender kopieren)",
    "icalError": "Der Abo-Link konnte nicht erzeugt werden."
  },
  "dashboard": {
    "kpiTotal": "Aufträge gesamt",
    "kpiOpen": "Offen",
    "kpiDone": "Abgeschlossen",
    "kpiOverdue": "Überfällige Fristen",
    "kpiRate": "Abgeschlossen in %",
    "statusChartTitle": "Aufträge je Stufe",
    "typeChartTitle": "Aufträge je Auftragsart",
    "funnelTitle": "Durchlauf: wie weit sind die Aufträge gekommen?",
    "upcomingTitle": "Nächste Fristen",
    "docTitle": "Dokumentationsfortschritt je Auftrag",
    "docProgress": "{{done}} von {{total}} Schritten erledigt",
    "docNone": "Keine laufenden Aufträge mit Arbeitsschritten.",
    "dataTable": "Daten als Tabelle",
    "colLabel": "Bezeichnung",
    "colCount": "Anzahl",
    "colReached": "Erreicht (mindestens)",
    "noData": "Noch keine Aufträge.",
    "readOnlyNote": "Nur Lesezugang. Preise werden hier nicht angezeigt.",
    "chartSummary": "{{title}}: {{items}}",
    "loadError": "Kennzahlen konnten nicht geladen werden.",
    "upcomingNone": "Keine anstehenden Fristen.",
    "orders": "Aufträge",
    "stage": {
      "intake": "Eingang",
      "dispatch": "Disposition",
      "work": "Ausführung",
      "review": "Prüfung",
      "client": "Auftraggeber",
      "billing": "Abrechnung",
      "cancelled": "Storniert"
    },
    "noType": "ohne Art",
    "acceptanceTitle": "Zur Abnahme gemeldet",
    "acceptanceNone": "Keine Aufträge warten auf Ihre Abnahme.",
    "acceptanceSince": "Gemeldet am {{date}}",
    "acceptanceHint": "Aufträge, die das GU Ihnen als fertig gemeldet hat. Die Abnahme tragen Sie dem GU gegenüber ein.",
    "acceptanceList": "Liste der Aufträge zur Abnahme"
  },
  "files": {
    "title": "Dateien",
    "empty": "Noch keine verifizierten Dateien.",
    "enlarge": "Vergrößern",
    "lightboxTitle": "Datei {{name}}",
    "close": "Schließen",
    "prev": "Vorherige Datei",
    "next": "Nächste Datei",
    "download": "Original öffnen",
    "time": "Aufnahmezeit",
    "gps": "GPS",
    "device": "Gerät",
    "hash": "Prüfsumme (SHA-256)",
    "status": "Status",
    "category": "Kategorie",
    "size": "Größe",
    "noGps": "ohne GPS-Fix",
    "none": "nicht angegeben",
    "document": "Dokument",
    "noPreview": "Keine Vorschau",
    "rejectedTitle": "Datei abgelehnt",
    "rejectedBody": "Diese Datei wurde nicht übernommen. Grund: {{reason}}",
    "loadError": "Dateien konnten nicht geladen werden.",
    "downloadError": "Das Original konnte nicht geladen werden.",
    "counter": "Datei {{index}} von {{total}}",
    "photo": "Foto",
    "statusValue": {
      "PENDING_UPLOAD": "Upload ausstehend",
      "VERIFYING": "Wird geprüft",
      "VERIFIED": "Verifiziert",
      "REJECTED": "Abgelehnt"
    },
    "rejectReason": {
      "HASH_MISMATCH": "Prüfsumme stimmt nicht",
      "SIZE_MISMATCH": "Größe stimmt nicht",
      "MALWARE": "Schadsoftware erkannt",
      "UNSUPPORTED_TYPE": "Dateityp nicht unterstützt"
    },
    "createdBy": "Erfasst von",
    "appVersion": "App-Version"
  },
  "formsAdmin": {
    "title": "Formulare",
    "description": "Formulardefinitionen laden, bearbeiten, mit dem Server auswerten und veröffentlichen.",
    "loadTitle": "Version laden",
    "keyLabel": "Schlüssel",
    "versionLabel": "Version",
    "load": "Laden",
    "known": "Bekannte Formulare",
    "statusValue": {
      "DRAFT": "Entwurf",
      "PUBLISHED": "Veröffentlicht",
      "RETIRED": "Zurückgezogen"
    },
    "editorLabel": "Formulardefinition (JSON)",
    "readOnlyNote": "Veröffentlichte Versionen sind unveränderbar. Für Änderungen legen Sie eine neue Version an.",
    "newVersion": "Als neue Version bearbeiten",
    "newForm": "Neues Formular aus Vorlage",
    "jsonError": "Kein gültiges JSON: {{message}}",
    "schemaOk": "Schema gültig",
    "schemaErrors": "Schemaverstöße ({{count}})",
    "saveDraft": "Entwurf speichern",
    "saved": "Entwurf {{key}} v{{version}} gespeichert.",
    "evaluate": "Mit Server auswerten",
    "evaluating": "Wird ausgewertet …",
    "serverResult": "Server-Auswertung",
    "drift": "Abweichung zwischen Browser und Server: {{fields}}",
    "noDrift": "Browser und Server stimmen überein.",
    "publish": "Veröffentlichen",
    "publishDescription": "Veröffentlichte Versionen sind unveränderbar und werden von Arbeitsschritten gepinnt. Jede spätere Änderung braucht eine neue Version.",
    "published": "Version {{version}} von {{key}} veröffentlicht.",
    "preview": "Vorschau",
    "previewHint": "Die Vorschau erscheint, sobald die Definition gültig ist.",
    "violations": "Der Server lehnt die Definition ab",
    "unsavedChanges": "Ungespeicherte Änderungen: erst speichern, dann veröffentlichen.",
    "referencePreview": "Referenzformulare ansehen",
    "loadFailed": "Diese Version gibt es nicht oder sie ist für Sie nicht sichtbar.",
    "saveFailed": "Der Entwurf wurde nicht gespeichert.",
    "current": "Geladen: {{key}} v{{version}}",
    "notLoaded": "Noch keine Definition geladen.",
    "versionMismatch": "Version im JSON ({{json}}) weicht von der geladenen Version ({{loaded}}) ab.",
    "serverNoDefinition": "Zum Auswerten zuerst eine gültige Definition laden oder eingeben.",
    "actions": "Aktionen zum Formular",
    "colForm": "Formular",
    "colStatus": "Status",
    "colPublished": "Veröffentlicht am"
  },
  "passkey": {
    "title": "Schneller anmelden mit Fingerabdruck oder Face-ID",
    "body": "Mit einem Passkey ersetzt Ihr Fingerabdruck oder Gesicht das Passwort. Die Einrichtung dauert eine Minute und ist jederzeit im Nutzermenü möglich.",
    "setup": "Jetzt einrichten",
    "later": "Später"
  },
  "review": {
    "openCount": "{{count}} Prüfpunkte offen",
    "filterKind": "Art",
    "filterFlag": "Grund",
    "filterArea": "Gebiet",
    "listLabel": "Prüfpunkte",
    "emptyTitle": "Nichts zu prüfen",
    "emptyBody": "Zu diesen Filtern gibt es keine offenen Prüfpunkte.",
    "loadError": "Die Prüfwarteschlange konnte nicht geladen werden.",
    "kind": {
      "VISIT": "Besuch",
      "PHOTO": "Foto",
      "MEASUREMENT": "Aufmaß"
    },
    "flag": {
      "backdated": "Rückdatiert",
      "photo_time_implausible": "Fotozeit unplausibel",
      "open_too_long": "Zu lange offen",
      "off_site": "Abseits der Baustelle",
      "no_fix": "Ohne GPS-Fix",
      "clock_skew": "Uhr weicht ab",
      "capped": "Stunden gekappt",
      "joined_later": "Später dazugekommen",
      "departure_missing": "Abfahrt fehlt",
      "rejected": "Abgelehnt",
      "hash_mismatch": "Prüfsumme stimmt nicht",
      "malware": "Schadsoftware",
      "measurement_submitted": "Zur Freigabe"
    },
    "org": "Erfasst von",
    "created": "Eingegangen",
    "arrived": "Ankunft",
    "departed": "Abfahrt",
    "location": "Standort",
    "clockCorrected": "Uhrzeit vom Server korrigiert",
    "locationStatus": {
      "ON_SITE": "Auf der Baustelle",
      "OFF_SITE": "Abseits",
      "NO_FIX": "Ohne GPS-Fix"
    },
    "attendance": "Anwesenheit",
    "colPerson": "Person",
    "colStart": "Beginn",
    "colEnd": "Ende",
    "colHours": "Stunden",
    "colFlags": "Hinweise",
    "openEnd": "offen",
    "photoCategory": "Bildkategorie",
    "capturedAt": "Aufgenommen",
    "gpsFix": "GPS-Fix",
    "gpsYes": "ja",
    "gpsNo": "nein",
    "rejectReason": "Ablehnungsgrund",
    "noPreview": "Keine Vorschau",
    "measurementLines": "Positionen",
    "colPosition": "Position",
    "colQuantity": "Menge",
    "colUnit": "Einheit",
    "colNote": "Notiz",
    "acceptVisit": "Besuch freigeben",
    "rejectVisit": "Besuch zurückweisen",
    "acceptPhoto": "Foto annehmen",
    "retakePhoto": "Neu aufnehmen lassen",
    "approveMeasurement": "Aufmaß freigeben",
    "returnMeasurement": "Aufmaß zurückgeben",
    "acceptVisitHint": "Die Stunden des Besuchs werden übernommen.",
    "rejectVisitHint": "Die Stunden dieses Besuchs werden gesperrt. Die Begründung sehen Prüfung und Nachunternehmer.",
    "retakeHint": "Der Nachunternehmer bekommt eine Aufgabe, das Foto neu aufzunehmen.",
    "returnHint": "Das Aufmaß geht mit Ihrer Begründung an den Nachunternehmer zurück.",
    "approveHint": "Das Aufmaß wird freigegeben und kann abgerechnet werden.",
    "done": "Entschieden: {{action}}.",
    "actions": "Aktionen zum Prüfpunkt",
    "noRight": "Für Entscheidungen fehlt das Recht.",
    "flags": "Prüfgründe"
  },
  "fieldwork": {
    "title": "Feldarbeit",
    "visits": "Besuche und Stunden",
    "visitsEmpty": "Noch keine Besuche.",
    "pits": "Gruben",
    "pitsEmpty": "Noch keine Gruben.",
    "measurements": "Aufmaße",
    "measurementsEmpty": "Noch keine Aufmaße.",
    "pitState": {
      "offen": "Offen",
      "provisorisch": "Provisorisch verschlossen",
      "fertig": "Fertig"
    },
    "pitDetail": {
      "asphalt_fehlt": "Asphalt fehlt",
      "pflaster_fehlt": "Pflaster fehlt"
    },
    "measurementStatus": {
      "SUBMITTED": "Zur Freigabe",
      "APPROVED": "Freigegeben",
      "RETURNED": "Zurückgegeben"
    },
    "barrierTaken": "Absperrung mitgenommen",
    "visitOpen": "Besuch offen seit {{date}}",
    "visitClosed": "{{from}} bis {{to}}",
    "loadError": "Feldarbeit konnte nicht geladen werden."
  },
  "areas": {
    "title": "Gebiete",
    "description": "Aufträge je Gebiet mit offenen Aufträgen, Fristen und offenen Gruben, als Liste und auf der Karte.",
    "listTitle": "Liste",
    "mapTitle": "Karte",
    "mapLabel": "Karte der Gebiete. Dieselben Gebiete stehen daneben als Liste.",
    "showOrders": "Aufträge anzeigen: {{key}}",
    "bundle": "Tagesbündel zuweisen",
    "bundleFor": "Tagesbündel zuweisen: {{key}}",
    "bundleCount": "{{count}} klassifizierte Aufträge im Gebiet werden gebündelt.",
    "bundleNone": "Im Gebiet gibt es keine klassifizierten Aufträge zum Bündeln.",
    "openOrders": "{{count}} offen",
    "pits": "{{count}} Gruben offen",
    "noArea": "(ohne Gebiet)",
    "noLocation": "Gebiete ohne Mittelpunkt sind nicht auf der Karte, aber in der Liste.",
    "loadError": "Gebiete konnten nicht geladen werden."
  },
  "pits": {
    "layer": "Ebene",
    "layerOrders": "Aufträge",
    "layerPits": "Gruben",
    "filterState": "Grubenzustand",
    "filterDetail": "Fehlender Belag",
    "listTitle": "Gruben auf der Karte ({{count}})",
    "mapLabel": "Karte der Gruben. Dieselben Gruben stehen darunter als Liste.",
    "empty": "Keine Gruben zu diesen Filtern.",
    "loadError": "Gruben konnten nicht geladen werden.",
    "noLocation": "{{count}} Gruben ohne Standort sind nicht auf der Karte, aber in der Liste.",
    "barrier": "Absperrung",
    "barrierYes": "mitgenommen",
    "barrierNo": "vorhanden"
  },
  "dispatch": {
    "title": "Wochenplan",
    "description": "Aufträge per Ziehen auf Kolonne und Tag terminieren. Sperren sehen Sie, bevor Sie ziehen.",
    "prevWeek": "Vorwoche",
    "nextWeek": "Nächste Woche",
    "thisWeek": "Diese Woche",
    "weekOf": "Woche vom {{date}}",
    "candidatesTitle": "Nicht terminiert",
    "candidatesHint": "Auf einen Tag und eine Kolonne ziehen, oder „Terminieren …“ wählen (auch per Tastatur).",
    "noCandidates": "Keine Aufträge zum Terminieren.",
    "gridLabel": "Wochenplan nach Kolonne und Tag",
    "crewHeader": "Kolonne",
    "noCrews": "Es gibt keine eigenen Kolonnen.",
    "empty": "frei",
    "schedule": "Terminieren …",
    "reschedule": "Umplanen …",
    "dragHint": "Ziehen zum Terminieren",
    "locked": "Gesperrt",
    "notSchedulable": "Terminieren ist derzeit nicht möglich",
    "blockedDays": "Gesperrt am {{days}}: {{reason}}",
    "slotBlocked": "Gesperrt: {{reason}}",
    "dropHere": "Hier ablegen",
    "dialogTitle": "Auftrag terminieren",
    "dialogHint": "{{number}} wird für die gewählte Kolonne und den Tag terminiert.",
    "crew": "Kolonne",
    "day": "Tag",
    "time": "Beginn",
    "blockedOption": "{{label}} (gesperrt: {{reason}})",
    "pickCrew": "Bitte wählen",
    "done": "{{number}} terminiert: {{day}}, {{crew}}.",
    "loadError": "Der Wochenplan konnte nicht geladen werden.",
    "ofCrew": "{{crew}}, {{day}}",
    "blockedNow": "Dieses Ziel ist gesperrt.",
    "at": "{{time}} Uhr",
    "notAcceptedYet": "Zuerst vergeben bzw. annehmen, dann terminieren"
  },
  "problem": {
    "unavailable": "Der Dienst ist gerade nicht erreichbar. Bitte später erneut versuchen.",
    "stale": "Der Datensatz wurde zwischenzeitlich geändert. Bitte neu laden und erneut versuchen.",
    "PERMIT_MAILBOX_UNAVAILABLE": "Das Antragspostfach ist gerade nicht erreichbar. Der Antrag bleibt freigegeben; senden Sie ihn später über „Einreichen“.",
    "PERMIT_MAIL_FAILED": "Die E-Mail an die Behörde konnte nicht versendet werden. Der Antrag bleibt freigegeben; bitte später erneut senden.",
    "PERMIT_APPLICATION_INCOMPLETE": "Pflichtangaben oder Pflichtanlagen fehlen: {{missing}}.",
    "PERMIT_APPLICATION_EXISTS": "Für diese Genehmigungsart läuft bereits ein Antrag. Nutzen Sie Verlängerung oder Neuantrag.",
    "PERMIT_APPLICATION_NOT_DRAFT": "Nur Entwürfe lassen sich bearbeiten oder freigeben.",
    "PERMIT_APPLICATION_NOT_APPROVED": "Nur freigegebene Anträge werden eingereicht.",
    "PERMIT_APPLICATION_NOT_SUBMITTED": "Der Antrag ist noch nicht eingereicht.",
    "PERMIT_NOT_EXTENDABLE": "Diese Genehmigung ist nicht verlängerbar. Stellen Sie einen Neuantrag.",
    "PERMIT_NOT_GRANTED": "Nur erteilte Genehmigungen lassen sich verlängern.",
    "PERMIT_PERIOD_TOO_LONG": "Die Behörde erteilt höchstens {{maxDays}} Tage.",
    "PERMIT_AUTHORITY_WITHOUT_EMAIL": "Für diese Behörde ist keine E-Mail-Adresse hinterlegt.",
    "PERMIT_CATALOG_MISSING": "Für diese Gemeinde und Genehmigungsart fehlt der Katalogeintrag.",
    "PERMIT_FILE_INVALID": "Die gewählte Datei gehört nicht zu diesem Auftrag oder ist nicht verifiziert.",
    "BILLING_CHECKLIST_INCOMPLETE": "Nicht alle Prüfpunkte sind erfüllt: {{open}}. Bestehen setzt alle Punkte voraus; sonst zurückgeben.",
    "BILLING_REVIEW_MISSING": "Das Kostenblatt wurde noch nicht geprüft.",
    "BILLING_NOT_INVOICED": "Es ist noch keine Rechnung erfasst.",
    "COST_SHEET_LOCKED": "Das Kostenblatt ist gesperrt und lässt sich nicht mehr ändern.",
    "COST_SHEET_NOT_DRAFT": "Nur Entwürfe lassen sich ändern.",
    "COST_SHEET_WRONG_STATUS": "Im aktuellen Status ist diese Aktion nicht möglich.",
    "MEASUREMENT_NOT_APPROVED": "Das Aufmaß ist noch nicht freigegeben.",
    "PRICE_LIST_MISSING": "Es gibt keine aktive Preisliste.",
    "ORDER_NOT_BILLABLE": "Dieser Auftrag ist noch nicht abrechenbar.",
    "UPLOAD_TYPE": "Nur PDF, JPEG, PNG oder HEIC sind erlaubt.",
    "UPLOAD_REJECTED": "Die Datei wurde bei der Prüfung abgelehnt.",
    "UPLOAD_PENDING": "Die Datei wird noch geprüft. Bitte kurz warten und erneut wählen.",
    "PERMIT_ATTACHMENT_INVALID": "Eine Anlage gehört nicht zu diesem Auftrag oder ist nicht verifiziert.",
    "CREW_NAME_TAKEN": "Eine Kolonne mit diesem Namen gibt es schon.",
    "USER_EMAIL_TAKEN": "Diese E-Mail-Adresse ist bereits vergeben."
  },
  "blockerCode": {
    "ORDER_PERMIT_MISSING": "Es liegt keine gültige Genehmigung vor.",
    "PERMIT_MISSING": "Es liegt keine gültige Genehmigung vor.",
    "PERMIT_MISSING_AT_START": "Zum Starttermin liegt keine gültige Genehmigung vor.",
    "PERMIT_CATALOG_MISSING": "Für diese Gemeinde fehlt der Eintrag im Behördenkatalog. Bitte im Katalog ergänzen.",
    "ORDER_TYPE_UNKNOWN": "Die Auftragsart ist unbekannt. Bitte klassifizieren.",
    "CREW_SET_BY_GC": "Die Kolonne hat das GU gesetzt und lässt sich nicht ändern.",
    "CREW_ONLY_OWN_ASSIGNMENT": "Eine Kolonne lässt sich nur für die eigene Zuweisung wählen.",
    "CREW_NOT_EXECUTOR": "Die gewählte Person darf keine Aufträge ausführen und ist keine Kolonne."
  },
  "permits": {
    "title": "Genehmigungen",
    "create": "Antrag anlegen",
    "statusValid": "Es liegt eine gültige Genehmigung vor oder keine wird verlangt.",
    "statusMissing": "Es fehlt eine gültige Genehmigung:",
    "reason": {
      "MISSING": "Für „{{type}}“ liegt keine Genehmigung vor.",
      "NOT_VALID_ON_DAY": "Die Genehmigung „{{type}}“ gilt am Einsatztag nicht.",
      "ORDER_TYPE_UNKNOWN": "Die Auftragsart ist unbekannt, die Genehmigungspflicht lässt sich nicht beurteilen. Bitte klassifizieren.",
      "CATALOG_MISSING": "Für diese Gemeinde fehlt der Eintrag im Behördenkatalog. Bitte im Katalog ergänzen."
    },
    "validRange": "(gültig {{from}} – {{to}})",
    "loadError": "Die Genehmigungen konnten nicht geladen werden.",
    "empty": "Noch kein Antrag für diesen Auftrag.",
    "history": {
      "created": "Entwurf angelegt",
      "approved": "Zur Einreichung freigegeben",
      "submitted": "Eingereicht",
      "decided": "Bescheid erfasst"
    },
    "historyTitle": "Verlauf ({{count}})",
    "direction": {
      "OUT": "Ausgang",
      "IN": "Eingang"
    },
    "messageKind": {
      "APPLICATION": "Antrag",
      "FOLLOW_UP": "Nachfassen",
      "RECEIPT": "Eingangsbestätigung",
      "DECISION": "Bescheid",
      "OTHER": "Sonstiges"
    },
    "messageStatus": {
      "SENT": "versendet",
      "FAILED": "fehlgeschlagen",
      "MATCHED": "zugeordnet",
      "UNMATCHED": "nicht zugeordnet"
    },
    "status": {
      "DRAFT": "Entwurf",
      "APPROVED": "Freigegeben",
      "SUBMITTED": "Eingereicht",
      "GRANTED": "Erteilt",
      "REJECTED": "Abgelehnt",
      "WITHDRAWN": "Zurückgezogen",
      "SUPERSEDED": "Ersetzt"
    },
    "kind": {
      "NEW": "Neuantrag",
      "EXTENSION": "Verlängerung",
      "RENEWAL": "Erneuerung"
    },
    "replaceReason": "Grund: {{reason}}",
    "period": "Beantragter Zeitraum",
    "field": {
      "location_address": "Ort der Arbeiten",
      "cadastralParcel": "Katasterparzelle",
      "trench_lengthM": "Grabenlänge (m)",
      "trench_widthM": "Grabenbreite (m)",
      "trench_depthM": "Grabentiefe (m)",
      "trafficResponsible_name": "Verantwortliche Person",
      "trafficResponsible_phone": "Telefon der verantwortlichen Person",
      "trafficScheme": "Verkehrsführung",
      "remarks": "Bemerkungen"
    },
    "attachment": {
      "ROUTE_SKETCH": "Straßenskizze / Lageplan",
      "TRAFFIC_SCHEME": "Verkehrszeichenplan",
      "ENGINEER_DECLARATION": "Erklärung des Ingenieurs",
      "FEE_PROOF": "Gebührennachweis",
      "CADASTRAL_EXTRACT": "Katasterauszug",
      "OWNER_CONSENT": "Zustimmung des Eigentümers",
      "OTHER": "Sonstiges"
    },
    "outcome": {
      "GRANTED": "Erteilt",
      "REJECTED": "Abgelehnt"
    },
    "fileNumber": "Aktenzeichen",
    "validity": "Gültigkeit",
    "conditions": "Auflagen",
    "edit": "Bearbeiten",
    "approve": "Freigeben",
    "submit": "Einreichen",
    "followUp": "Nachfassen",
    "decision": "Bescheid erfassen",
    "extension": "Verlängern",
    "renewal": "Neuantrag",
    "saved": "{{number}} gespeichert.",
    "approved": "{{number}} freigegeben.",
    "submitted": "{{number}} eingereicht.",
    "followedUp": "Nachfassen zu {{number}} versendet.",
    "decided": "Bescheid zu {{number}} erfasst.",
    "created": "{{number}} angelegt.",
    "createHint": "Der Antrag wird aus den Auftragsdaten vorbefüllt. Ohne Zeitraum gilt der vorgeschlagene.",
    "permitType": "Genehmigungsart",
    "from": "Von",
    "to": "Bis",
    "periodHint": "Die Behörde kann die Dauer begrenzen.",
    "editHint": "Ergänzen Sie fehlende Angaben. Anlagen kommen nur aus den verifizierten Dateien dieses Auftrags.",
    "noAttachment": "Keine Datei",
    "attachmentHint": "Fehlt eine Datei, laden Sie sie zuerst beim Auftrag unter Dateien hoch.",
    "approveHint": "Prüft Pflichtangaben und Pflichtanlagen. Bei Einreichung per E-Mail geht der Antrag sofort an die Behörde; ohne Freigabe wird nichts verschickt.",
    "submitHint": "Der freigegebene Antrag wird erneut versendet bzw. als eingereicht vermerkt.",
    "followUpHint": "Diese Nachfrage geht an die Behörde. Die nächste Nachfassfrist rückt danach nach.",
    "draftError": "Der Entwurf konnte nicht geladen werden.",
    "mailTo": "An",
    "mailSubject": "Betreff",
    "mailBody": "Text",
    "decisionHint": "Erfasst den Bescheid der Behörde. Bei Erteilung wird die Gültigkeit als Frist überwacht.",
    "outcomeLabel": "Ergebnis",
    "decidedOn": "Bescheid vom",
    "validFrom": "Gültig ab",
    "validTo": "Gültig bis",
    "decisionFile": "Bescheid (PDF oder Bild)",
    "renewalHint": "Der laufende Antrag wird ersetzt. Der Grund ist Pflicht und wird protokolliert.",
    "mailbox": {
      "record": "Eingang erfassen",
      "unmatchedTitle": "Nicht zugeordnete Eingänge",
      "emptyTitle": "Alles zugeordnet",
      "emptyBody": "Es gibt keine Eingänge ohne Antrag. Die Zuordnung läuft über die Antragsnummer [ANT-JJJJ-NNNNN] im Betreff.",
      "recordHint": "Erfasst einen Eingang manuell. Enthält der Betreff die Antragsnummer [ANT-JJJJ-NNNNN], wird er dem Antrag zugeordnet.",
      "kind": "Art",
      "matched": "Eingang erfasst und dem Antrag zugeordnet.",
      "unmatched": "Eingang erfasst, aber keinem Antrag zugeordnet."
    },
    "saveDraft": "Entwurf speichern",
    "catalogEmpty": "Für diese Gemeinde ist keine Antragsart im Katalog hinterlegt.",
    "catalogMandatory": "Pflichtanlagen",
    "catalogDays": "Typische Bearbeitungszeit: {{days}} Arbeitstage"
  },
  "billing": {
    "title": "Abrechnung",
    "clientAmount": "Betrag Auftraggeber",
    "subAmount": "Betrag Subunternehmer",
    "margin": "Marge",
    "subTitle": "Sub-Abrechnung",
    "loadError": "Die Abrechnung konnte nicht geladen werden.",
    "subNone": "Noch keine Sub-Abrechnung.",
    "subStatus": {
      "DRAFT": "Entwurf",
      "APPROVED": "Freigegeben"
    },
    "total": "Summe",
    "col": {
      "no": "Nr.",
      "kind": "Art",
      "position": "Position",
      "text": "Text",
      "quantity": "Menge",
      "unit": "Einheit",
      "unitPrice": "Einzelpreis",
      "amount": "Betrag",
      "actions": "Aktionen"
    },
    "deviation": {
      "NOT_IN_CATALOG": "Nicht im Leistungsverzeichnis",
      "NO_PRICE": "Ohne Preis"
    },
    "kind": {
      "SERVICE": "Leistung",
      "WORK": "Arbeit",
      "MATERIAL": "Material"
    },
    "status": {
      "DRAFT": "Entwurf",
      "REVIEWED": "Geprüft",
      "RETURNED": "Zurückgegeben",
      "SUBMITTED": "In IDBM übertragen",
      "CLIENT_APPROVED": "Von HT bestätigt",
      "CLIENT_REJECTED": "Von HT abgelehnt",
      "BILLED": "Abgerechnet"
    },
    "regenerate": "Neu erzeugen",
    "generate": "Kostenblatt erzeugen",
    "addLine": "Zeile ergänzen",
    "pass": "Prüfung bestehen",
    "returnSheet": "Zurückgeben",
    "submit": "In IDBM übertragen",
    "decision": "Entscheidung HT erfassen",
    "invoice": "Rechnung erfassen",
    "none": "Noch kein Kostenblatt. Es entsteht aus dem freigegebenen Aufmaß.",
    "lineDeleted": "Zeile gelöscht.",
    "showTransfer": "Übertragungsansicht anzeigen",
    "hideTransfer": "Übertragungsansicht ausblenden",
    "generateHint": "Mengen je Position werden aus dem freigegebenen Aufmaß summiert, Preise kommen aus der aktiven Preisliste. Ergänzte Zeilen bleiben erhalten.",
    "generated": "Kostenblatt erzeugt.",
    "lineAdded": "Zeile ergänzt.",
    "passed": "Prüfung bestanden: Kostenblatt geprüft.",
    "returned": "Kostenblatt zurückgegeben.",
    "submitted": "In IDBM übertragen.",
    "decided": "Entscheidung von HT erfasst.",
    "invoiced": "Rechnung erfasst: abgerechnet.",
    "idbmNumber": "Nummer in IDBM",
    "submitHint": "Tragen Sie die Nummer ein, unter der das Kostenblatt in IDBM angelegt wurde.",
    "invoiceNumber": "Rechnungsnummer",
    "invoiceHint": "Danach ist am Auftrag „Als abgerechnet markieren“ möglich.",
    "revision": "Revision {{revision}}",
    "flow": "Ablauf der Abrechnung",
    "returnedBecause": "Zurückgegeben: {{reason}}",
    "rejectedBecause": "Von HT abgelehnt: {{reason}}",
    "idbmDifference": "IDBM-Differenz {{amount}} (bestätigt: {{approved}})",
    "idbmNumberValue": "IDBM-Nummer: {{number}}",
    "invoiceNumberValue": "Rechnung: {{number}}",
    "linesLabel": "Zeilen des Kostenblatts",
    "deleteLine": "Zeile {{no}} löschen",
    "delete": "Löschen",
    "transferError": "Die Übertragungsansicht ist erst nach bestandener Prüfung verfügbar.",
    "transferHint": "Felder in der Reihenfolge der IDBM-Maske, ohne Preise. Jedes Feld lässt sich einzeln kopieren.",
    "transferLabel": "Übertragungsansicht für IDBM",
    "copyField": "Feld kopieren: {{field}}",
    "copied": "Kopiert: {{field}}.",
    "downloadXlsx": "XLSX herunterladen",
    "downloadError": "Der Download ist fehlgeschlagen.",
    "lineHint": "Arbeits- oder Materialzeile ergänzen. Material braucht die EDM-Nummer.",
    "edmNo": "EDM-Nummer",
    "warehouse": "Lager",
    "batch": "Batch",
    "serialNo": "Seriennummer",
    "checklist": "Prüfpunkte",
    "passHint": "Bestehen setzt alle Prüfpunkte voraus. Danach ist die Übertragung in IDBM möglich.",
    "returnHint": "Das Kostenblatt geht mit Ihrer Begründung an den Sub zurück.",
    "check": {
      "measurement_matches_photos": "Aufmaß passt zu den Fotos",
      "documents_complete": "Dokumente vollständig",
      "positions_match_catalog": "Positionen entsprechen dem Leistungsverzeichnis",
      "materials_recorded": "Material erfasst"
    },
    "decisionHint": "Entscheidung von HT aus IDBM. Kostenblatt: {{total}}. Eine Ablehnung geht mit Grund an den Sub zurück.",
    "outcome": "Entscheidung",
    "outcomeApproved": "Bestätigt",
    "outcomeRejected": "Abgelehnt",
    "approvedAmount": "Bestätigter Betrag",
    "rejectReason": "Grund der Ablehnung"
  },
  "classification": {
    "suggestion": "Vorschlag der KI-Klassifikation: {{type}} ({{percent}} % sicher)",
    "hint": "Unter der Schwelle bestätigt die Disposition die Auftragsart.",
    "confirm": "Vorschlag bestätigen",
    "other": "Andere Auftragsart wählen",
    "confirmHint": "Der Auftrag wird als „{{type}}“ klassifiziert.",
    "otherHint": "Wählen Sie die Auftragsart, mit der der Auftrag klassifiziert wird.",
    "done": "Auftrag als „{{type}}“ klassifiziert.",
    "type": {
      "INSTALLATION": "Installation",
      "FAULT": "Störung",
      "RELOCATION": "Umzug",
      "DISCONNECTION": "Abschaltung",
      "CIVIL_WORKS": "Tiefbau"
    }
  },
  "combobox": {
    "placeholder": "Auswählen oder suchen …",
    "empty": "Keine Treffer",
    "unavailable": "Die Liste ist nicht verfügbar.",
    "clear": "Auswahl entfernen",
    "noneChosen": "Keine Auswahl",
    "remove": "Entfernen: {{name}}"
  },
  "crewAdmin": {
    "create": "Kolonne anlegen",
    "showInactive": "Inaktive Kolonnen anzeigen",
    "loadError": "Kolonnen konnten nicht geladen werden.",
    "loadErrorBody": "Bitte später erneut versuchen.",
    "active": "Aktiv",
    "inactive": "Inaktiv",
    "edit": "Bearbeiten",
    "activate": "Aktivieren",
    "deactivate": "Deaktivieren",
    "leader": "Vorarbeiter",
    "members": "Mitglieder ({{count}})",
    "activateHint": "Kolonne „{{name}}“ wird wieder aktiviert und ist bei der Disposition wählbar.",
    "deactivateHint": "Kolonne „{{name}}“ wird deaktiviert und ist bei der Disposition nicht mehr wählbar. Bestehende Termine bleiben bestehen.",
    "activated": "Kolonne „{{name}}“ aktiviert.",
    "deactivated": "Kolonne „{{name}}“ deaktiviert.",
    "save": "Kolonne speichern",
    "createHint": "Name festlegen, Vorarbeiter und Mitglieder aus den Nutzern Ihrer Organisation wählen.",
    "editHint": "Name, Vorarbeiter, Mitglieder und Status ändern.",
    "name": "Name",
    "nameTaken": "Eine Kolonne mit diesem Namen gibt es schon.",
    "membersLabel": "Mitglieder",
    "activeLabel": "Kolonne ist aktiv",
    "saved": "Kolonne „{{name}}“ gespeichert.",
    "created": "Kolonne „{{name}}“ angelegt.",
    "org": "Organisation",
    "ownOrg": "Eigene Organisation"
  },
  "admin": {
    "tab": {
      "users": "Nutzer",
      "organizations": "Organisationen",
      "sites": "Standorte"
    },
    "search": "Suche (Name oder E-Mail)",
    "createUser": "Nutzer anlegen",
    "createUserHint": "Der Nutzer erhält ein einmaliges Startpasswort oder einen Einladungslink. Beides wird nur einmal angezeigt.",
    "col": {
      "name": "Name",
      "email": "E-Mail",
      "org": "Organisation",
      "role": "Rolle",
      "sites": "Standorte",
      "status": "Status",
      "actions": "Aktionen"
    },
    "editRole": "Rolle ändern",
    "editRoleHint": "Rolle, Standorte und Status von {{name}} ändern.",
    "newOnboarding": "Neues Startpasswort",
    "onboardingHint": "Für {{name}} wird ein neues einmaliges Startpasswort bzw. ein Einladungslink erzeugt. Der bisherige Zugang wird ungültig.",
    "userCreated": "Nutzer {{name}} angelegt.",
    "userSaved": "Nutzer {{name}} gespeichert.",
    "loadError": "Die Daten konnten nicht geladen werden.",
    "loadErrorBody": "Bitte später erneut versuchen.",
    "secretTitle": "Zugang für {{name}}",
    "secretOnce": "Dieser Zugang wird nur jetzt angezeigt. Danach kann ihn niemand mehr abrufen, auch nicht die Administration.",
    "tempPassword": "Startpasswort",
    "inviteLink": "Einladungslink",
    "copy": "Kopieren",
    "copied": "Kopiert",
    "secretNone": "Der Server hat keinen Zugang geliefert.",
    "validUntil": "Gültig bis {{date}}",
    "secretWarning": "Geben Sie den Zugang nur persönlich oder über einen sicheren Kanal weiter.",
    "secretClose": "Notiert, schließen",
    "createOrg": "Organisation anlegen",
    "createOrgHint": "Name und Art festlegen. Standorte und Nutzer legen Sie danach an.",
    "orgCreated": "Organisation {{name}} angelegt.",
    "orgKindLabel": "Art",
    "orgKind": {
      "GC": "Generalunternehmer (GU)",
      "SUB": "Nachunternehmer",
      "CLIENT": "Auftraggeber"
    },
    "createSite": "Standort anlegen",
    "createSiteHint": "Ein Standort gehört zu einer Organisation und begrenzt, welche Aufträge ein Nutzer sieht.",
    "siteCreated": "Standort {{name}} angelegt.",
    "siteName": "Name des Standorts",
    "sitesEmptyTitle": "Noch keine Standorte",
    "sitesEmptyBody": "Legen Sie Standorte an, um den Zugriff von Nutzern einzugrenzen.",
    "pickOrgFirst": "Bitte zuerst eine Organisation wählen.",
    "activeLabel": "Nutzer ist aktiv",
    "locale": "Sprache",
    "sendInvite": "Einladung per E-Mail senden statt Startpasswort",
    "userInvited": "Nutzer {{name}} angelegt, die Einladung wurde verschickt.",
    "saveRoles": "Rollen speichern",
    "revoke": "Entziehen",
    "revokeRole": "Rolle entziehen: {{name}}",
    "newRole": "neu",
    "addRole": "Rolle hinzufügen",
    "scopeSite": "Eingegrenzt auf Standort (optional)",
    "allSites": "Alle Standorte",
    "addRoleButton": "Rolle vormerken",
    "profile": "Profil des Auftraggebers",
    "siteCode": "Kürzel des Standorts",
    "siteAddress": "Adresse (optional)"
  },
  "history": {
    "title": "Verlauf",
    "immutable": "Jede Version und jedes Ereignis wird unveränderbar und verkettet gespeichert (revisionssicher). Einträge lassen sich weder ändern noch löschen.",
    "noPrices": "Preise und Margen sind in Ihrem Verlauf nicht enthalten.",
    "version": "Version {{version}}",
    "event": "Ereignis",
    "system": "System",
    "hash": "Prüfsumme",
    "hashHint": "Prüfsumme der Verkettung; sie ändert sich bei jeder nachträglichen Manipulation.",
    "changesOf": "Änderungen: {{summary}}",
    "col": {
      "field": "Feld",
      "from": "Vorher",
      "to": "Nachher"
    },
    "more": "Ältere Einträge laden",
    "loadError": "Der Verlauf konnte nicht geladen werden.",
    "loadErrorBody": "Bitte später erneut versuchen.",
    "emptyTitle": "Noch kein Verlauf",
    "emptyBody": "Versionen und Ereignisse dieses Auftrags erscheinen hier.",
    "field": {
      "address": "Adresse",
      "status": "Status",
      "orderType": "Auftragsart",
      "scheduledStart": "Termin",
      "crew": "Kolonne",
      "price": "Preis",
      "assigneeOrgId": "Nachunternehmer",
      "clientStatus": "Status des Auftraggebers",
      "externalRef": "Externe Referenz",
      "rajon": "Rajon",
      "municipality": "Gemeinde"
    },
    "action": {
      "CREATED": "Angelegt",
      "REVISED": "Geändert",
      "SUBMITTED": "Eingereicht",
      "STATUS_CHANGED": "Status geändert",
      "SCHEDULE": "Termin geändert",
      "CREW_CHANGED": "Kolonne gewechselt",
      "REQUEST_SCHEDULE": "Terminwunsch",
      "DELETED": "Gelöscht"
    }
  },
  "permitFiles": {
    "title": "Anlagen",
    "required": "Pflicht",
    "requiredMissing": "Diese Pflichtanlage fehlt noch.",
    "state": {
      "missing": "Nicht hochgeladen",
      "UPLOADED": "Hochgeladen",
      "VERIFIED": "Geprüft",
      "REJECTED": "Abgelehnt"
    },
    "upload": "{{kind}} hochladen",
    "replace": "{{kind}} ersetzen",
    "uploading": "Wird hochgeladen …",
    "saved": "Anlage „{{kind}}“ gespeichert.",
    "rejectedBody": "Die Datei wurde abgelehnt. Grund: {{reason}}",
    "rejectedUnknown": "unbekannt",
    "hintDraft": "Anlagen lassen sich im Entwurf hochladen und ersetzen. Erlaubt sind PDF, JPEG, PNG und HEIC.",
    "hintLocked": "Nach der Freigabe sind die Anlagen gesperrt.",
    "template": "Offizielle Formularvorlagen der Gemeinde",
    "templateDownload": "{{name}} herunterladen",
    "templateError": "Die Vorlage konnte nicht geladen werden.",
    "templateSource": "Quelle",
    "templateRetrieved": "abgerufen am {{date}}",
    "loadError": "Die Anlagen konnten nicht geladen werden.",
    "note": "Notiz",
    "noteLabel": "Notiz zu {{kind}} (optional)",
    "noteLabelOther": "Notiz zur nächsten sonstigen Anlage (optional)",
    "noteSave": "Notiz speichern",
    "noteSaved": "Notiz zu „{{kind}}“ gespeichert.",
    "remove": "{{kind}} entfernen",
    "removed": "Anlage „{{kind}}“ entfernt.",
    "add": "{{kind}} hinzufügen",
    "otherItem": "Datei {{n}}",
    "otherCount": "Dateien: {{count}}"
  },
  "pitPhotos": {
    "show": "Fotos anzeigen",
    "pick": "Grube wählen, um die Fotos der drei Phasen zu sehen.",
    "title": "Fotos der Grube {{label}}",
    "missing": "Fotos fehlen für: {{phases}}.",
    "phase": {
      "VOR_OEFFNEN": "Vor dem Öffnen",
      "WAEHREND_ARBEITEN": "Während der Arbeiten",
      "NACH_SCHLIESSEN": "Nach dem Schließen"
    },
    "none": "Keine Fotos in dieser Phase.",
    "notDueYet": "Noch nicht fällig: Die Grube ist noch offen.",
    "photoError": "Das Foto konnte nicht geladen werden.",
    "loadError": "Die Grube konnte nicht geladen werden."
  },
  "search": {
    "label": "Aufträge suchen",
    "placeholder": "Auftrag suchen (Nummer, Adresse) …",
    "hint": "Mindestens zwei Zeichen eingeben",
    "none": "Kein Auftrag gefunden",
    "error": "Die Suche ist gerade nicht verfügbar"
  },
  "requested": {
    "set": "Terminwunsch setzen",
    "clear": "Terminwunsch löschen",
    "hint": "Der Wunschtermin ist unverbindlich und ändert den Status nicht. Den verbindlichen Termin setzt die Disposition.",
    "clearHint": "Der Terminwunsch wird entfernt.",
    "note": "Hinweis (optional)",
    "past": "Der Wunschtermin muss in der Zukunft liegen.",
    "saved": "Terminwunsch gespeichert.",
    "cleared": "Terminwunsch gelöscht.",
    "label": "Terminwunsch",
    "noteLabel": "Hinweis zum Terminwunsch",
    "crew": "Kolonne"
  }
}
